/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_Other_BodyInputs */

const en_us2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workout still open on another device will be ended. Its sets stay saved, but it will not move your plan forward. Then this one syncs, with every set you logged here.`)
};

const pt_br2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treino ainda aberto em outro aparelho será encerrado. As séries dele continuam salvas, mas ele não avança o seu plano. Depois este sincroniza, com todas as séries que você registrou aqui.`)
};

const es_419_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se terminará el entrenamiento que sigue abierto en otro dispositivo. Sus series quedan guardadas, pero no hará avanzar tu plan. Después este se sincroniza, con todas las series que registraste aquí.`)
};

const pt_pt2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treino ainda aberto noutro dispositivo será terminado. As séries dele continuam guardadas, mas não faz avançar o teu plano. Depois este sincroniza, com todas as séries que registaste aqui.`)
};

const fr_fr2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La séance encore ouverte sur un autre appareil sera terminée. Ses séries restent enregistrées, mais elle ne fera pas avancer ton programme. Ensuite celle-ci se synchronise, avec toutes les séries notées ici.`)
};

const de_de2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Training, das auf einem anderen Gerät noch offen ist, wird beendet. Seine Sätze bleiben gespeichert, aber es bringt deinen Plan nicht weiter. Danach wird dieses synchronisiert, mit allen Sätzen, die du hier eingetragen hast.`)
};

const it_it2_offline_end_other_body = /** @type {(inputs: Offline_End_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'allenamento ancora aperto su un altro dispositivo verrà chiuso. Le sue serie restano salvate, ma non farà avanzare la tua scheda. Poi questo si sincronizza, con tutte le serie che hai registrato qui.`)
};

/**
* | output |
* | --- |
* | "The workout still open on another device will be ended. Its sets stay saved, but it will not move your plan forward. Then this one syncs, with every set you ..." |
*
* @param {Offline_End_Other_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other_body = /** @type {((inputs?: Offline_End_Other_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_Other_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other_body(inputs)
	if (locale === "es-419") return es_419_offline_end_other_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other_body(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other_body(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other_body(inputs)
	return en_us2_offline_end_other_body(inputs)
});
export { offline_end_other_body as "offline.end_other_body" }